<button [ngClass]="classes" [disabled]="disabled" (click)="clickEvent.emit($event)">
	<i *ngIf="icon && iconPosition && iconPosition !== 'left'" [ngClass]="icon"></i>
	<ng-content *ngIf="!label"></ng-content>
	<ng-container *ngIf="label">
		{{ label }}
	</ng-container>
	<i *ngIf="icon && iconPosition && iconPosition == 'left'" [ngClass]="icon"> </i>
</button>
